import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DocumentFileDownloadStatus} from "../model/document-file-download-status";

@Injectable({
  providedIn: 'root'
})
export class DocumentFileService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Retrieves the download status of document files specified by their ids.
   *
   * @param documentFileIds List of Ids of the document files for which the download status should be retrieved
   * @return Observable containing an array of all retrieved document file download status objects
   */
  public getDocumentFileDownloadStatusForFiles(documentFileIds: number[]): Observable<DocumentFileDownloadStatus[]>{
    return this.httpClient.post<DocumentFileDownloadStatus[]>("/api/batch/download-status",documentFileIds);
  }
}
